import PageMeta from "../../components/common/PageMeta";
import {
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import Tabs from "../../components/ui/Tabs"
import StylistPage from "./StylistPage";
import RealStylistPage from "./RealStylistPage";

const StylistTabs = () => {

    return (
        <>
            <PageMeta
                title={`Stylist - ${DEFAULT_PAGE_TITLE}`}
                description={`Stylist - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <PageBreadcrumb pageTitle="Stylist" />
            <Tabs
                tabs={[
                     {
                        label: "Virtual Stylist",
                        content: (
                            <div>
                                <div>
                                    <StylistPage />
                                </div>
                            </div>
                        ),
                    },
                    {
                        label: "Real Stylist",
                        content: (
                            <div>
                                 <div>
                                    <RealStylistPage />
                                </div>

                            </div>
                        ),
                    },
                   
                ]}
            />

        </>
    );
};

export default StylistTabs;
